import { TablePagination } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import FormContainer from "../../../../../../common/components/form_container";
import { StyledDataGrid } from "../../../../../../common/components/styled_data_grid";
import { GridRowSelectionModel } from "@mui/x-data-grid-pro";
import { useMemo } from "react";
import { CentroCustoRestricaoUsuario } from "../../../../domain/models/centro_custo_restricao_usuario";
import { GenerateRestricaoCentroCustoColumns } from "../columns/restricao_centro_custo";

/**
 * Grupo Acesso Table
 */

type Props = {
  loading: boolean,
  saving: boolean,
  gridRowSelectionModel: GridRowSelectionModel,
  centroCustoRestricoes: CentroCustoRestricaoUsuario[],
  page: number,
  rowsPerPage: number,
  totalItems: number,
  onPageChange: (page: number) => void,
  onRowsPerPageChange: (rowsPerPage: number) => void,
  onSelectionModelChange: (selectionModel: GridRowSelectionModel) => void,
};

export const TabelaCentroCustoRestricao = ({
  loading,
  gridRowSelectionModel,
  centroCustoRestricoes,
  page,
  rowsPerPage,
  totalItems,
  onPageChange,
  onRowsPerPageChange,
  onSelectionModelChange,

}: Props) => {

  const columnsDef = useMemo(() => {
    return GenerateRestricaoCentroCustoColumns();
  }, []);

  return (
    <>
      <CascateList
        title="Selecione os centros de custo que o usuário poderá acessar"
        defaultOpen={false}>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <FormContainer title='Selecione o Centro de Custo' arrangement='fullRow' border={false}>
            <>
              <StyledDataGrid
                tableName="centro_custo_restricao"
                getRowHeight={() => 'auto'}
                disableColumnMenu={false}
                getRowId={(row: CentroCustoRestricaoUsuario) => row.idCentroCusto}
                checkboxSelection={true}
                rowSelectionModel={gridRowSelectionModel}
                onRowSelectionModelChange={onSelectionModelChange}
                columns={columnsDef}
                loading={loading}
                rows={centroCustoRestricoes}
                rowCount={centroCustoRestricoes.length}
                pageSizeOptions={[100]}
                paginationMode="server"
                paginationModel={{
                  page: page,
                  pageSize: rowsPerPage,
                }} />

              <TablePagination
                component="div"
                count={totalItems}
                page={page - 1}
                rowsPerPageOptions={[100]}
                onPageChange={(_, p) => onPageChange(p)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value))} />
            </>
          </FormContainer>

        </div>
      </CascateList>
    </>
  );
}